import config from '../../../../../../../../config'

import { LOAD_HISTORY, HISTORY_LOADED, LOAD_HISTORY_REQUEST } from './constants'

export function loadHistory() {
    return {
        type: LOAD_HISTORY,
    }
}

export function loadHistoryRequest() {
    return {
        type: LOAD_HISTORY_REQUEST,
        payload: {
            ...config.api.entityStack.history.get,
            qs: {
                limit: config.components.entityStack.history.limit,
            },
        },
    }
}

export function historyLoaded(entities) {
    return {
        type: HISTORY_LOADED,
        data: {
            entities,
        },
    }
}
